import { create } from 'zustand';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSignalStore = create((set, get) => ({
  signals: [],
  loading: false,
  error: null,
  filters: { type: 'all', severity: 'all' },

  fetchSignals: async (limit = 50) => {
    set({ loading: true, error: null });
    try {
      const { data } = await axios.get(`${API}/signals/unified`, {
        params: { limit },
      });
      set({ signals: data.signals || [], loading: false });
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || 'Failed to load signals';
      set({ error: msg, loading: false });
    }
  },

  recordAction: async (signalId, signalSource, actionType) => {
    try {
      await axios.post(`${API}/signals/${signalId}/action`, {
        signal_source: signalSource,
        action_type: actionType,
      });
      if (actionType === 'dismiss') {
        set(s => ({
          signals: s.signals.map(sig =>
            sig.id === signalId ? { ...sig, dismissed: true } : sig
          ),
        }));
        toast.success('Signal dismissed');
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || 'Action failed');
    }
  },

  setFilter: (key, value) => {
    set(s => ({ filters: { ...s.filters, [key]: value } }));
  },

  getFilteredSignals: () => {
    const { signals, filters } = get();
    return signals.filter(s => {
      if (s.dismissed) return false;
      if (filters.type !== 'all' && s.source !== filters.type) return false;
      if (filters.severity !== 'all' && s.severity !== filters.severity) return false;
      return true;
    });
  },
}));
